import NetPayReportComponent from 'components/Report/NetPayReport';
import PermissionGuard from 'components/Global/PermissionGuard'; // adjust the path if necessary

const NetPayReport = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<NetPayReportComponent />
		</PermissionGuard>
	);
};

export default NetPayReport;
